import { AppPageContentWrapper, CircularTextLoader, PageContentBox, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { resetRudiAdditionalDocRequest } from "../../../../store/redux/slice/Forms/rudiAdditionalDocForm";

const RudiAdditionalDocNew = () => {
  const dispatch = useAppDispatch();

  const rudiAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RudiAdditionalDocForm;
  });

  useEffect(() => {
    dispatch(resetRudiAdditionalDocRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {rudiAdditionalDocForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={rudiAdditionalDocForm.steps}
              applicationSubtype={"RUDI_ADDITIONAL_DOCUMENTS"}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default RudiAdditionalDocNew;
